export default __webpack_public_path__ + "static/media/profile.923a96c3.svg";